module.exports = __webpack_public_path__ + "static/media/ellipse.2018bfb3.svg";